<template>
    <div>
        <page-title>商盟等级编辑</page-title>
        <page-body>
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item label="等级名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <br>
                    <div style="font-size: 12px;color: #909399;line-height: 1.5">数字越小排序越靠前，最小1</div>
                    <el-input v-model="form.sort" step="1" min="1" type="number"></el-input>
                </el-form-item>
                <el-form-item label="等级说明" prop="content">
                    <el-input v-model="form.content" type="textarea"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit" :loading="submitLoading">保存</el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<script>
export default {
    name: 'LevelEdit',
    data() {
        return {
            form: {
                id: null,
                name: '',
                sort: 100,
                content: ''
            },
            rules: {
                name: [
                    {
                        required: true, message: '请填写等级名称'
                    }
                ],
                content: [
                    {
                        required: true, message: '请填写等级说明'
                    }
                ]
            },
            submitLoading: false
        }
    },
    created() {
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.$request({
                url: 'admin/mch/level-detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                console.log(e)
                if (e.code === 0) {
                    this.form.name = e.data.name
                    this.form.sort = e.data.sort
                    this.form.content = e.data.content
                }
            }).catch(() => {
            })
        },
        submit() {
            this.$refs['form'].validate(v => {
                if (v) {
                    this.submitLoading = true
                    this.$request({
                        url: 'admin/mch/level-save',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.submitLoading = false
                        if (e.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.replace('/dashboard/admin/mch/level')
                        } else {
                            this.$message.error(e.msg)
                        }
                    }).catch(() => {
                    })
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
